document.addEventListener('DOMContentLoaded', function() {
  // Get all required elements
  const nextButton = document.querySelector('.npl-quiz-sticky-next');
  const backButton = document.querySelector('.npl-quiz-sticky-back');
  const backContainer = document.querySelector('.npl-quiz-sticky-back-container');
  const stepItems = document.querySelectorAll('.npl-quiz-step-item');
  const progressFill = document.querySelector('.npl-quiz-progress-fill');
  const progressLabel = document.querySelector('.npl-quiz-progress-label');
  const answerItems = document.querySelectorAll('.npl-quiz-step-item-answer-item');
  const results = document.querySelector('.npl-quiz-results');

  const totalSteps = stepItems.length || 10; // fallback

  function getCurrentStep() {
    const activeStep = document.querySelector('.npl-quiz-step-item.active');
    return activeStep ? parseInt(activeStep.dataset.step) : 1;
  }

  // Update progress bar and label
  function updateProgress(stepNumber) {
    const pct = Math.max(0, Math.min(100, (stepNumber / totalSteps) * 100));
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressLabel) progressLabel.textContent = `Step ${stepNumber} of ${totalSteps}`;
  }

  function updateBackButton(stepNumber) {
    if (backContainer) {
      if (stepNumber >= 2) backContainer.classList.add('active');
      else backContainer.classList.remove('active');
    }
  }

  function navigateToStep(stepNumber) {
    stepItems.forEach(item => item.classList.remove('active'));
    const targetStep = document.querySelector(`.npl-quiz-step-item[data-step="${stepNumber}"]`);
    if (targetStep) {
      targetStep.classList.add('active');
      updateProgress(stepNumber);
      updateBackButton(stepNumber);
    }
  }

  // Next button
  if (nextButton) {
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      const currentStep = getCurrentStep();

      if (currentStep === totalSteps) {
        const loadingScreen = document.querySelector('.npl-quiz-loading');
        const loadingText = document.querySelector('.npl-quiz-loading-text');

        if (loadingScreen) {
          loadingScreen.classList.add('active');

          setTimeout(() => { if (loadingText) loadingText.textContent = 'Almost there...'; }, 4000);
          setTimeout(() => {
            loadingScreen.classList.remove('active');
            if (results) results.classList.add('active');
          }, 8000);
        }
      } else if (currentStep < totalSteps) {
        navigateToStep(currentStep + 1);
      }
    });
  }

  // Back button
  if (backButton) {
    backButton.addEventListener('click', function(e) {
      e.preventDefault();
      const currentStep = getCurrentStep();
      if (currentStep > 1) navigateToStep(currentStep - 1);
    });
  }

  // Answer item click handlers
    answerItems.forEach(item => {
    item.addEventListener('click', function(e) {
        e.preventDefault();

        const stepItem = this.closest('.npl-quiz-step-item');
        const step = stepItem ? stepItem.dataset.step : null;

        if (step === "3" || step === "11") {
        // 👉 Step 3 & Step 11 = multi-select
        this.classList.toggle('active');
        } else {
        // 👉 Other steps = single-select
        const parentList = this.closest('.npl-quiz-step-item-answer-list');
        if (parentList) {
            parentList.querySelectorAll('.npl-quiz-step-item-answer-item')
                    .forEach(answer => answer.classList.remove('active'));
            this.classList.add('active');
        }
        }
    });
    });

    const quizState = window.quizState || (window.quizState = {});

            // capture gender when clicked
    document.querySelectorAll('.npl-quiz-step-item[data-step="1"] .npl-card-option')
    .forEach(card => {
        card.addEventListener('click', () => {
        quizState.gender = card.dataset.value; // "male" | "female"
        });
    });

    // --- Coupon copy UX --- 
    (function setupCouponCopy() {
      const couponBox = document.getElementById('nplquizCouponCode');
      if (!couponBox) return;

      const TEXT_SELECTOR = '.npl-quiz-results-pb-text';
      const textEl = couponBox.querySelector(TEXT_SELECTOR);
      if (!textEl) return;

      const COUPON_CODE = 'QUIZ10';
      const RESTORE_DELAY = 1600; // 1.6s (tweak 1000-2000ms as you like)
      const COPIED_CLASS = 'copied'; // you'll add CSS for this
      let busy = false; // prevent re-entrancy during the flash

      // Keep the original HTML to restore later (includes your <b>QUIZ10</b> etc.)
      const originalHTML = textEl.innerHTML;

      async function copyToClipboard(text) {
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
          }
          // Fallback for older browsers / non-secure contexts
          const ta = document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          const ok = document.execCommand('copy');
          document.body.removeChild(ta);
          return ok;
        } catch (e) {
          return false;
        }
      }

      function makeSuccessNode(message) {
        const el = document.createElement('div');
        el.className = 'npl-quiz-results-pb-success hidden'; // style as you like
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.textContent = message;
        return el;
      }

      couponBox.addEventListener('click', async (e) => {
        e.preventDefault();
        if (busy) return;
        busy = true;

        const didCopy = await copyToClipboard(COUPON_CODE);
        const msg = didCopy ? 'Code copied!' : 'Copy failed — try again';

        // 1) Add a class for styling (e.g., green glow, etc.)
        couponBox.classList.add(COPIED_CLASS);

        // 2) Replace the inner text temporarily
        textEl.textContent = msg;

        // 3) Inject a success node right AFTER the main box (as requested)
        const successNode = makeSuccessNode(msg);
        couponBox.insertAdjacentElement('afterend', successNode);

        // 4) Restore after delay
        setTimeout(() => {
          textEl.innerHTML = originalHTML;
          couponBox.classList.remove(COPIED_CLASS);
          successNode.remove();
          busy = false;
        }, RESTORE_DELAY);
      });
    })();


  // Init
  updateProgress(1);
  updateBackButton(1);
});
